import { Observable } from 'rxjs';

import { ChangeDetectionStrategy, Component, Inject, Input, Optional, ViewChild } from '@angular/core';

import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

import { PaymentMethodsNewComponent } from '../new/payment-methods-new.component';

@Component({
  standalone: false,
  selector: 'adspt-payment-method-setup',
  templateUrl: 'payment-method-setup.component.html',
  styleUrls: ['payment-method-setup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodSetupComponent {
  @ViewChild(PaymentMethodsNewComponent, { static: true })
  paymentComponent: PaymentMethodsNewComponent;

  @Input()
  secondary?: boolean;

  @Input()
  replace?: string;

  @Input()
  newSubscription?: boolean;

  get form$() {
    return this.paymentComponent?.form$;
  }

  confirm(): Observable<boolean> {
    return this.paymentComponent.submitForm();
  }

  constructor(@Optional() @Inject(NZ_MODAL_DATA) data: Partial<PaymentMethodSetupComponent>) {
    Object.keys(data || {}).forEach((key) => (this[key] = data[key]));
  }
}
